import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    // CRITICAL: si retour du callback OAuth Google, AuthCallback gère l'échange — ne pas vérifier /me ici.
    if (window.location.hash?.includes('session_id=')) {
      setUser(null);
      return;
    }
    const token = localStorage.getItem('tf_token');
    const req = token
      ? api.get('/auth/me', { headers: { Authorization: `Bearer ${token}` } })
      : api.get('/auth/me', { withCredentials: true });
    req.then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem('tf_token'); setUser(null); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('tf_token', data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post('/auth/register', { name, email, password });
    localStorage.setItem('tf_token', data.access_token);
    setUser(data.user);
    return data.user;
  };

  const completeOAuth = async (sessionId) => {
    const { data } = await api.post('/auth/session', { session_id: sessionId }, { withCredentials: true });
    localStorage.setItem('tf_token', data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    api.post('/auth/logout', {}, { withCredentials: true }).catch(() => {});
    localStorage.removeItem('tf_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, completeOAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
